export default {
  login: {
    welcome: 'वापसी पर स्वागत है',
    subtitle: 'खरीदारी जारी रखने के लिए लॉग इन करें',
    phonePlaceholder: 'फ़ोन नंबर दर्ज करें',
    passwordPlaceholder: 'पासवर्ड दर्ज करें',
    showPassword: 'दिखाएं',
    hidePassword: 'छिपाएं',
    loginButton: 'लॉग इन करें',
    registerButton: 'मुफ्त पंजीकरण',
    title: 'लॉग इन करें',
    subtitle2: 'इनाम प्राप्त करने के लिए एक-स्टॉप ग्लोबल शॉपिंग',
    logging: 'लॉग इन हो रहा है...',
    phoneRequired: 'फ़ोन नंबर दर्ज करें',
    passwordRequired: 'पासवर्ड दर्ज करें',
    loginSuccess: 'लॉग इन सफल',
    loginFailed: 'लॉग इन विफल',
    loginError: 'लॉग इन त्रुटि, बाद में पुनः प्रयास करें'
  },
  register: {
    title: 'खाता बनाएं',
    subtitle: 'हमसे जुड़ें और अपनी ट्रेडिंग यात्रा शुरू करें',
    username: 'उपयोगकर्ता नाम',
    phone: 'फ़ोन नंबर',
    loginPassword: 'लॉग इन पासवर्ड',
    transactionPassword: 'लेनदेन पासवर्ड',
    invitationCode: 'निमंत्रण कोड',
    usernamePlaceholder: 'उपयोगकर्ता नाम दर्ज करें',
    phonePlaceholder: 'फ़ोन नंबर दर्ज करें',
    loginPasswordPlaceholder: 'लॉग इन पासवर्ड दर्ज करें',
    transactionPasswordPlaceholder: 'लेनदेन पासवर्ड दर्ज करें',
    invitationCodePlaceholder: 'निमंत्रण कोड दर्ज करें',
    registerButton: 'पंजीकरण करें',
    hasAccount: 'पहले से खाता है? लॉग इन करें',
    errorUsername: 'उपयोगकर्ता नाम दर्ज करें',
    errorPhone: 'फ़ोन नंबर दर्ज करें',
    errorLoginPassword: 'लॉग इन पासवर्ड दर्ज करें',
    errorTransactionPassword: 'लेनदेन पासवर्ड दर्ज करें',
    errorInviteCode: 'निमंत्रण कोड दर्ज करें',
    registerSuccess: 'पंजीकरण सफल'
  },
  tabbar: {
    home: 'होम',
    purchase: 'ऑर्डर इतिहास',
    grabbing: 'ऑर्डर करें',
    kefu: 'ग्राहक सेवा',
    my: 'मेरा'
  },
  home: {
    orderCount: 'ऑर्डर की संख्या',
    upgradeAmount: 'रिचार्ज और अपग्रेड',
    recharge: 'रिचार्ज',
    withdraw: 'निकासी',
    team: 'टीम प्रबंधन',
    commission: 'कमीशन प्राप्त करें',
    newProducts: 'नए उत्पाद',
    newProductsDesc: 'नए सीज़न और भविष्य के संग्रह के नवीनतम शैलियाँ।',
    buyNow: 'अभी खरीदें',
    nowAvailable: 'अभी उपलब्ध',
    nowAvailableDesc: 'शादी के सीज़न के लिए तैयार हों, अपनी अगली यात्रा के लिए सामान पैक करें और बिना किसी प्रतिबद्धता के अपना वॉर्डरोब अपडेट करें। हमारे नए लोन प्लान के साथ, आप नवीनतम रुझानों को आज़मा सकते हैं और सब्सक्रिप्शन के बिना अपने बजट में रह सकते हैं।',
    footerTitle: 'Desigual.com',
    footerFollow: "{'@'}Desigual.com पर हमें फॉलो करें और अपने पसंदीदा Desigual.com लुक्स साझा करें!",
    footerShop: 'हमारी कैटलॉग ब्राउज़ करें'
  },
  purchase: {
    all: 'सभी',
    pending: 'लंबित',
    completed: 'पूर्ण',
    frozen: 'जमे हुए',
    balance: 'खाता शेष',
    orderTime: 'ऑर्डर समय',
    orderId: 'ऑर्डर नंबर',
    totalAmount: 'कुल राशि',
    commission: 'कमीशन',
    expectedReturn: 'अपेक्षित वापसी',
    submitOrder: 'ऑर्डर जमा करें',
    orderCompleted: 'ऑर्डर पूर्ण',
    loading: 'लोड हो रहा है...',
    noData: 'कोई ऑर्डर डेटा नहीं',
    noMore: 'और नहीं',
    orderSuccess: 'ऑर्डर सफल',
    orderNumber: 'ऑर्डर नंबर',
    rating: 'रेटिंग',
    notSubmit: 'अभी नहीं जमा करें',
    submitNow: 'अभी जमा करें',
    submitting: 'जमा हो रहा है...',
    submitFailed: 'जमा करना विफल',
    grabOrderFailed: 'ऑर्डर लेना विफल, बाद में पुनः प्रयास करें',
    getOrderInfoFailed: 'ऑर्डर विवरण प्राप्त करना विफल',
    submitOrderFailed: 'जमा करना विफल, बाद में पुनः प्रयास करें'
  },
  common: {
    home: 'होम',
    about: 'के बारे में',
    contact: 'संपर्क करें',
    purchase: 'ऑर्डर इतिहास',
    grabbing: 'ऑर्डर करें',
    my: 'मेरा',
    login: 'लॉग इन करें',
    register: 'पंजीकरण करें',
    kefu: 'ग्राहक सेवा',
    loadDataError: 'डेटा लोड करना विफल, बाद में पुनः प्रयास करें',
    success: 'ऑपरेशन सफल',
    failed: 'ऑपरेशन विफल',
    submitSuccess: 'जमा सफल',
    submitFailed: 'जमा विफल',
    submitting: 'जमा हो रहा है...'
  },
  grabbing: {
    accountAmount: 'खाता राशि',
    accountBalance: 'खाता शेष',
    getCommission: 'कमीशन प्राप्त करें',
    ordersGrabbedToday: 'आज लिए गए ऑर्डर',
    orderCount: 'ऑर्डर की संख्या',
    operationSteps: 'ऑपरेशन चरण',
    step1: '1. कार्य शुरू करें बटन पर क्लिक करें और निर्देशों के अनुसार कार्य पूरा करें',
    step2: '2. कार्य पूरा होने के बाद, आप कमीशन को शेष में सेटल कर सकते हैं',
    grabOrder: 'ऑर्डर लें',
    pleaseWait: 'कृपया प्रतीक्षा करें',
    grabSuccess: 'ऑर्डर सफल',
    grabTime: 'ऑर्डर समय',
    grabNumber: 'ऑर्डर नंबर',
    orderTotal: 'कुल राशि',
    commission: 'कमीशन',
    expectedReturn: 'अपेक्षित वापसी',
    rating: 'रेटिंग',
    notSubmit: 'अभी नहीं जमा करें',
    submitNow: 'अभी जमा करें',
    submitting: 'जमा हो रहा है...'
  },
  kefu: {
    title: 'ग्राहक सेवा',
    intro: {
      line1: 'यदि आपके कोई प्रश्न या सहायता की आवश्यकता है,',
      line2: 'समाधान के लिए ग्राहक सेवा से संपर्क करें'
    },
    serviceTime: {
      label: 'सेवा समय',
      text: 'आपकी विशेष ग्राहक सेवा',
      online: 'ऑनलाइन'
    },
    contact: {
      title: 'संपर्क',
      name: 'ऑनलाइन',
      status: 'परामर्श',
      feature1: 'तत्काल उत्तर',
      feature2: 'पेशेवर सेवा',
      button: 'संपर्क करें'
    },
    faq: {
      title: 'अक्सर पूछे जाने वाले प्रश्न',
      rechargeQuestion: 'रिचार्ज कैसे करें?',
      rechargeAnswer: 'आप हमारे सुरक्षित भुगतान गेटवे के माध्यम से रिचार्ज कर सकते हैं। मेरा खाता > रिचार्ज पर जाएं और निर्देशों का पालन करें।',
      withdrawQuestion: 'निकासी कैसे करें?',
      withdrawAnswer: 'निकासी मेरा खाता > निकासी के माध्यम से की जा सकती है। सुनिश्चित करें कि आपका खाता सत्यापित है।',
      minRechargeQuestion: 'न्यूनतम रिचार्ज राशि क्या है?',
      minRechargeAnswer: 'न्यूनतम रिचार्ज राशि ${currency}68 है।',
      withdrawTimeQuestion: 'निकासी में कितना समय लगता है?',
      withdrawTimeAnswer: 'निकासी आमतौर पर 24 घंटे के भीतर संसाधित हो जाती है।',
      securityQuestion: 'क्या मेरी जानकारी सुरक्षित है?',
      securityAnswer: 'हाँ, हम आपकी व्यक्तिगत और वित्तीय जानकारी की सुरक्षा के लिए उद्योग मानक एन्क्रिप्शन तकनीक का उपयोग करते हैं।'
    }
  },
  my: {
    inviteCode: 'निमंत्रण कोड',
    copy: 'कॉपी करें',
    copySuccess: 'कॉपी सफल',
    copyFailed: 'कॉपी विफल',
    online: 'ऑनलाइन',
    accountAmount: 'खाता राशि',
    balance: 'खाता शेष',
    accountBalanceTrend: 'खाता शेष',
    todayCommission: 'आज का कमीशन',
    totalCommission: 'कुल कमीशन',
    today: 'आज',
    total: 'कुल',
    todayOrders: 'आज लिए गए ऑर्डर',
    orderCount: 'ऑर्डर की संख्या',
    recharge: 'रिचार्ज',
    withdraw: 'निकासी',
    rechargeRecord: 'रिचार्ज इतिहास',
    withdrawRecord: 'निकासी इतिहास',
    accountDetails: 'खाता विवरण',
    receivingAccount: 'प्राप्ति खाता',
    bankAccount: 'बैंक खाता',
    bankAccountDesc: 'बैंक खाता',
    usdt: 'USDT',
    usdtDesc: 'USDT पता',
    connect: 'कनेक्ट करें',
    teamManagement: 'टीम प्रबंधन',
    viewTeam: 'टीम देखें',
    changePassword: 'पासवर्ड बदलें',
    changeWithdrawPassword: 'निकासी पासवर्ड बदलें',
    passwordSettings: 'पासवर्ड सेटिंग्स',
    logout: 'लॉग आउट',
    signOut: 'लॉग आउट',
    version: 'संस्करण'
  },
  changePasswordPage: {
    currentPassword: 'वर्तमान लॉग इन पासवर्ड',
    currentPasswordPlaceholder: 'वर्तमान पासवर्ड दर्ज करें',
    newPassword: 'नया लॉग इन पासवर्ड',
    newPasswordPlaceholder: 'नया पासवर्ड दर्ज करें',
    confirmPassword: 'लॉग इन पासवर्ड की पुष्टि करें',
    confirmPasswordPlaceholder: 'नया पासवर्ड की पुष्टि करें',
    notice: 'लॉग इन पासवर्ड खाता तक पहुँचने के लिए उपयोग किया जाता है। सुरक्षा सुनिश्चित करने के लिए पासवर्ड में कम से कम 6 वर्ण होने चाहिए और इसमें अक्षर और अंक शामिल होने चाहिए।',
    updateButton: 'लॉग इन पासवर्ड अपडेट करें',
    errorOldPassword: 'वर्तमान पासवर्ड दर्ज करें',
    errorNewPassword: 'नया पासवर्ड दर्ज करें',
    errorConfirmPassword: 'नया पासवर्ड की पुष्टि करें',
    errorPasswordMismatch: 'पासवर्ड मेल नहीं खाते',
    errorPasswordLength: 'पासवर्ड में कम से कम 6 वर्ण होने चाहिए',
    errorPasswordFormat: 'पासवर्ड में अक्षर और अंक शामिल होने चाहिए'
  },
  changeWithdrawPasswordPage: {
    currentPassword: 'वर्तमान निकासी पासवर्ड',
    currentPasswordPlaceholder: 'वर्तमान निकासी पासवर्ड दर्ज करें',
    newPassword: 'नया निकासी पासवर्ड',
    newPasswordPlaceholder: 'नया निकासी पासवर्ड दर्ज करें',
    confirmPassword: 'निकासी पासवर्ड की पुष्टि करें',
    confirmPasswordPlaceholder: 'नया निकासी पासवर्ड की पुष्टि करें',
    notice: 'निकासी पासवर्ड धन निकासी ऑपरेशन के लिए उपयोग किया जाता है। सुरक्षा सुनिश्चित करने के लिए पासवर्ड में कम से कम 6 वर्ण होने चाहिए और इसमें अक्षर और अंक शामिल होने चाहिए।',
    updateButton: 'निकासी पासवर्ड अपडेट करें',
    errorOldPassword: 'वर्तमान निकासी पासवर्ड दर्ज करें',
    errorNewPassword: 'नया निकासी पासवर्ड दर्ज करें',
    errorConfirmPassword: 'नया निकासी पासवर्ड की पुष्टि करें',
    errorPasswordMismatch: 'पासवर्ड मेल नहीं खाते',
    errorPasswordLength: 'पासवर्ड में कम से कम 6 वर्ण होने चाहिए',
    errorPasswordFormat: 'पासवर्ड में अक्षर और अंक शामिल होने चाहिए'
  },
  details: {
    loading: 'लोड हो रहा है...',
    noRecords: 'कोई रिकॉर्ड नहीं',
    noMore: 'और नहीं',
    time: 'समय',
    type: 'प्रकार',
    amount: 'राशि',
    balance: 'शेष',
    remark: 'टिप्पणी',
    type0: 'अन्य',
    type1: 'रिचार्ज',
    type2: 'निकासी',
    type3: 'लेनदेन',
    type4: 'ऑर्डर कमीशन',
    type5: 'अधीनस्थ कमीशन',
    type8: 'निकासी अस्वीकृत'
  },
  rechargeRecord: {
    offline: 'ऑफलाइन रिचार्ज',
    online: 'ऑनलाइन रिचार्ज',
    loading: 'लोड हो रहा है...',
    noRecords: 'कोई रिकॉर्ड नहीं',
    orderNo: 'ऑर्डर नंबर',
    rechargeAmount: 'रिचार्ज राशि',
    rechargeTime: 'रिचार्ज समय',
    payMethod: 'भुगतान विधि',
    rechargeStatus: 'रिचार्ज स्थिति',
    noMore: 'और नहीं',
    statusPending: 'स्वीकृति की प्रतीक्षा में',
    statusApproved: 'स्वीकृत',
    statusFailed: 'विफल',
    statusEmpty: ''
  },
  withdrawRecord: {
    loading: 'लोड हो रहा है...',
    noRecords: 'कोई रिकॉर्ड नहीं',
    orderNo: 'ऑर्डर नंबर',
    withdrawAmount: 'निकासी राशि',
    withdrawTime: 'निकासी समय',
    withdrawAddress: 'निकासी पता',
    withdrawStatus: 'निकासी स्थिति',
    noMore: 'और नहीं',
    statusPending: 'प्रसंस्करण में',
    statusApproved: 'सफल',
    statusFailed: 'विफल',
    statusEmpty: ''
  },
  withdraw: {
    title: 'निकासी',
    method: 'निकासी विधि',
    methodSubtitle: 'अपनी निकासी विधि चुनें',
    bankInfo: 'बैंक खाता जानकारी',
    bankName: 'बैंक',
    accountHolder: 'खाताधारक का नाम',
    bankCard: 'बैंक कार्ड',
    amount: 'निकासी राशि',
    balance: 'शेष',
    withdrawAll: 'सब निकालें',
    paymentPassword: 'भुगतान पासवर्ड',
    passwordPlaceholder: 'धन पासवर्ड दर्ज करें',
    principal: 'मूल राशि',
    serviceFee: 'सेवा शुल्क',
    netAmount: 'शुद्ध राशि',
    notice: '*प्राप्ति जानकारी की सावधानी से जांच करें',
    withdrawButton: 'निकासी',
    walletAddress: 'वॉलेट पता',
    walletAddressSubtitle: 'वॉलेट पता दर्ज करें'
  },
  recharge: {
    title: 'रिचार्ज',
    amount: 'रिचार्ज राशि',
    amountSubtitle: 'रिचार्ज करने के लिए राशि दर्ज करें',
    quickSelect: 'त्वरित चयन',
    rechargeNow: 'अभी रिचार्ज करें',
    selectPayment: 'भुगतान विधि चुनें',
    selectPaymentSubtitle: 'अपनी पसंदीदा भुगतान विधि चुनें',
    cancel: 'रद्द करें',
    confirm: 'पुष्टि करें',
    crypto: 'क्रिप्टोकरेंसी',
    bank: 'बैंक ट्रांसफर',
    paymentRange: 'न्यूनतम: {symbol}{minAmount} - अधिकतम: {symbol}{maxAmount}',
    rechargeFailed: 'रिचार्ज विफल',
    paymentInfo: 'भुगतान जानकारी',
    usercode: 'USDT पता',
    uploadScreenshot: 'कृपया भुगतान स्क्रीनशॉट अपलोड करें',
    clickToUpload: 'स्क्रीनशॉट अपलोड करने के लिए क्लिक करें',
    copySuccess: 'सफलतापूर्वक कॉपी किया गया',
    copyFailed: 'कॉपी करने में विफल',
    uploadScreenshotRequired: 'कृपया भुगतान स्क्रीनशॉट अपलोड करें',
    submit: 'जमा करें',
    submitting: 'जमा कर रहा हूँ...',
    submitSuccess: 'सफलतापूर्वक जमा किया गया',
    submitFailed: 'जमा करने में विफल'
  },
  bindUsdt: {
    title: 'USDT बाइंड करें',
    cardTitle: 'USDT पता',
    cardSubtitle: 'अपना USDT वॉलेट पता दर्ज करें',
    walletAddress: 'वॉलेट पता',
    walletAddressPlaceholder: 'USDT वॉलेट पता दर्ज करें',
    networkType: 'नेटवर्क प्रकार',
    networkTypePlaceholder: 'नेटवर्क प्रकार चुनें',
    withdrawPassword: 'निकासी पासवर्ड',
    withdrawPasswordPlaceholder: 'निकासी पासवर्ड दर्ज करें',
    trc20: 'TRC20',
    trc20Network: 'TRC20 नेटवर्क',
    erc20: 'ERC20',
    erc20Network: 'ERC20 नेटवर्क',
    securityNotice: 'सुरक्षा नोटिस',
    securityText1: '• आपका USDT पता एन्क्रिप्ट किया गया है और सुरक्षित रूप से संग्रहीत है',
    securityText2: '• केवल आप इस जानकारी को देख और संशोधित कर सकते हैं',
    securityText3: '• सुनिश्चित करें कि सभी जानकारी सटीक है',
    buttonText: 'जानकारी सहेजें',
    buttonSubtitle: 'USDT पता बाइंड करें',
    errorWalletAddress: 'वॉलेट पता दर्ज करें',
    errorNetworkType: 'नेटवर्क प्रकार चुनें',
    errorWithdrawPassword: 'निकासी पासवर्ड दर्ज करें'
  },
  team: {
    title: 'टीम प्रबंधन',
    level1: 'स्तर 1 टीम',
    level2: 'स्तर 2 टीम',
    level3: 'स्तर 3 टीम',
    level1Members: 'स्तर 1 टीम सदस्य',
    level2Members: 'स्तर 2 टीम सदस्य',
    level3Members: 'स्तर 3 टीम सदस्य',
    totalMembers: 'कुल सदस्य',
    totalCommission: 'कुल कमीशन',
    members: 'लोग',
    orders: 'ऑर्डर',
    commission: 'कमीशन',
    noMembers: 'कोई सदस्य नहीं',
    loading: 'लोड हो रहा है...',
    noMore: 'और नहीं'
  },
  bindBank: {
    title: 'बैंक कार्ड बाइंड करें',
    cardTitle: 'बैंक जानकारी',
    cardSubtitle: 'अपना बैंक चुनें और खाता विवरण दर्ज करें',
    bankName: 'बैंक',
    bankNamePlaceholder: 'बैंक का नाम दर्ज करें',
    cardNumber: 'कार्ड नंबर',
    cardNumberPlaceholder: 'कार्ड नंबर दर्ज करें',
    realName: 'वास्तविक नाम',
    realNamePlaceholder: 'वास्तविक नाम दर्ज करें',
    withdrawPassword: 'निकासी पासवर्ड',
    withdrawPasswordPlaceholder: 'निकासी पासवर्ड दर्ज करें',
    securityNotice: 'सुरक्षा नोटिस',
    securityText1: '• आपकी बैंक जानकारी एन्क्रिप्ट की गई है और सुरक्षित रूप से संग्रहीत है',
    securityText2: '• केवल आप इस जानकारी को देख और संशोधित कर सकते हैं',
    securityText3: '• सुनिश्चित करें कि सभी जानकारी सटीक है',
    buttonText: 'जानकारी सहेजें',
    buttonSubtitle: 'बैंक खाता बाइंड करें',
    errorBankName: 'बैंक का नाम दर्ज करें',
    errorCardNumber: 'कार्ड नंबर दर्ज करें',
    errorRealName: 'वास्तविक नाम दर्ज करें',
    errorWithdrawPassword: 'निकासी पासवर्ड दर्ज करें'
  }
}
